module.exports = __webpack_public_path__ + "static/media/78.6639270a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/78.jpg
// module id = 1015
// module chunks = 0